<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Site Forms"
              icon="fas fa-list"
              buttonLabel="CREATE SITE FORM"
              buttonIcon="fas fa-plus"
              (buttonClick)="goToCreateForm()">
          </card-section-header>
          <div class="form-row">
            <div class="col-md-12 d-flex justify-content-end">
              <table-action-bar (toggleColumns)="columnOptionsSidebarVisible = true"></table-action-bar>
            </div>
          </div>
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table
                  [autoLayout]="true"
                  [value]="tableData"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
                  [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <ng-container *ngFor="let header of [
                      { dataName: 'siteForm.name', columnName: 'Name', sortable: true, alwaysShow: true },
                      { dataName: 'siteForm.siteOwnerUser.skylarkUser.user.firstName', columnName: 'Site Owner', sortable: true, alwaysShow: true },
                      { dataName: 'version', columnName: 'Version' },
                      { dataName: 'siteForm.createdDate', columnName: 'Created Date', sortable: true },
                      { dataName: 'createdDate', columnName: 'Last Updated', sortable: true },
                      { dataName: 'siteCount', columnName: 'Sites' }
                    ]">
                      <th *ngIf="header.alwaysShow || tableOptions.visibleColumns.includes(header.columnName)"
                          [pSortableColumn]="header.sortable ? header.dataName : false"
                      >
                        {{header.columnName}}
                        <p-sortIcon *ngIf="header.sortable" [field]="header.dataName"></p-sortIcon>
                      </th>
                    </ng-container>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr>
                    <td>{{ row.name }}</td>
                    <td>{{ row.siteOwnerName }}</td>
                    <td *ngIf="tableOptions.visibleColumns.includes('Version')">{{ row.version }}</td>
                    <td *ngIf="tableOptions.visibleColumns.includes('Created Date')"><date-friendly [value]="row.createdDate"></date-friendly></td>
                    <td *ngIf="tableOptions.visibleColumns.includes('Last Updated')"><date-friendly [value]="row.lastModifiedDate"></date-friendly></td>
                    <td *ngIf="tableOptions.visibleColumns.includes('Sites')">{{ row.linkedSites.length }}</td>
                    <td><a [routerLink]="[row.id]">view</a></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="5">No forms found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
